import React, { useState, useEffect } from 'react';
import { DollarSign } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MobileStickyQuoteCTA = ({ label = 'Get Instant Quote', targetPath = '/sell', scrollToId = null, contactAction = null }) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible && !contactAction) return null;

  const handleClick = () => {
    if (scrollToId) {
      const el = document.getElementById(scrollToId);
      if (el) { el.scrollIntoView({ behavior: 'smooth' }); return; }
    }
    // If we're already on the target path, scroll to top
    if (window.location.pathname === targetPath) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(targetPath);
    }
  };

  return (
    <div
      className={contactAction
        ? 'fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200 bg-white p-3 md:bottom-5 md:left-5 md:right-auto md:rounded-lg md:border md:shadow-lg'
        : 'fixed bottom-0 left-0 right-0 z-40 p-3 bg-slate-950/95 backdrop-blur-md border-t border-slate-800 md:hidden'}
      style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom, 0px))' }}
      data-testid="mobile-sticky-cta"
    >
      <div className={contactAction ? `${visible ? 'grid grid-cols-2 gap-2' : 'flex justify-center'} md:block` : ''}>
      {(!contactAction || visible) && <button
        onClick={handleClick}
        data-testid="mobile-sticky-quote-button"
        className={contactAction
          ? 'flex min-h-[48px] min-w-0 items-center justify-center rounded-lg bg-green-600 px-2 py-2 text-xs font-bold text-white transition-colors hover:bg-green-500 md:hidden'
          : 'w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-500 text-white font-bold py-3.5 rounded-xl transition-colors min-h-[44px]'}
      >
        {!contactAction && <DollarSign className="w-5 h-5" />}
        {label}
      </button>}
      {contactAction}
      </div>
    </div>
  );
};

export default MobileStickyQuoteCTA;
